import React from 'react';
import { Grid, Field, FieldLabel, Box, TextInput } from '@blueprint/ui';
import { LabelBox } from './LabelBox';
import { TextInputBox } from './TextInputBox';

const LabelInput = ({ label, value, name }) => {
    return (
        <Grid container>
            <Field name={name}>
                <Grid item xs={12} sm={2}>
                    <LabelBox>
                        <FieldLabel variant='body1'>{label}</FieldLabel>
                    </LabelBox>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInputBox>
                        <TextInput value={value} disabled />
                    </TextInputBox>
                </Grid>
            </Field>
        </Grid>
    );
};

export default LabelInput;
